export default function (fetch, baseUrl) {
  return {
    // Accounts
    getAccounts(data) {
      return fetch.get(`${baseUrl}/account`, { params: data });
    },
    createAccount(data) {
      return fetch.post(`${baseUrl}/account/create`, data);
    },


    // Transfers
    listTransfers(body) {
      return fetch.post(`${baseUrl}/transfer/list`, body);
    },
    // alias kept so other callers still work — remove once migrated
    getTransfers(body) {
      return fetch.post(`${baseUrl}/transfer/list`, body);
    },
    createTransfer(data) {
      return fetch.post(`${baseUrl}/transfer/one-time`, data);
    },
    processTransfer(transferId) {
      return fetch.put(`${baseUrl}/transfer/process/${transferId}`);
    },

    // Corporate Beneficiaries
    getCorporateBeneficiaries(data) {
      return fetch.get(`${baseUrl}/corporate-beneficiary`, { params: data });
    },
    createCorporateBeneficiary(data) {
      return fetch.post(`${baseUrl}/corporate-beneficiary/create`, data);
    },

    // Scheduled Transfers
    getScheduledTransfers(data) {
      return fetch.get(`${baseUrl}/scheduled-transfer`, { params: data });
    },
    createScheduledTransfer(data) {
      return fetch.post(`${baseUrl}/scheduled-transfer`, data);
    },
    updateScheduledTransfer(scheduledTransferId, data) {
      return fetch.put(`${baseUrl}/scheduled-transfer/${scheduledTransferId}`, data);
    },

    // Libra Dashboard Configs
    getLibraDashboardConfigs() {
      return fetch.get(`${baseUrl}/alphadesk/configs`);
    }
  };
}
